<template>
    <section id="saving-content">
        <div class="container">
            <div class="content">
                <span class="eyebrow-page omnes fw-semibold text-orange"
                    >Patient Savings</span
                >
                <h1 class="gtitle fw-semibold">
                    Regardless of coverage, commercially insured patients can
                    access JORNAY PM for as little as:
                </h1>
            </div>

            <div class="content img-container py-4">
                <img
                    class="d-none d-lg-block"
                    src="../../assets/img/savings/savings.png"
                    alt="Graphic showing several saving tiers, including $0, $25, and $75"
                />
                <img
                    class="d-block d-lg-none"
                    src="../../assets/img/savings/savings-mobile.png"
                    alt="Graphic showing several saving tiers, including $0, $25, and $75"
                />
            </div>
        </div>

        <div class="page-container savings-box-container">
            <div class="savings-box">
                <p class="fw-bold">
                    For the first fill, eligible, commercially insured patients
                    pay $0
                </p>
            </div>

            <p class="savings-note">
                See Terms and Conditions on
                <a href="https://www.jornaypm.com/savings" rel="noopener noreferrer"
                    target="_blank">Patient Savings Page</a>.
            </p>
        </div>
    </section>
</template>

<script>
export default {
    components: {},
};
</script>
